import { useAppSelector } from '../reduxHooks';
const useCheckAllLoaded = () => {
    var _a;
    const [isLoadedResumoCart, isLoadedResumoCartPerf, isLoadedPerfHist, isLoadedPosCon, isLoadedCartExp, isLoadedFluxoAtivos, isLoadedEstats, isLoadedCapaPDF, isPercentToggle, preferenceCustomizacao, preferenceLiberacao,] = useAppSelector((state) => [
        state.resumoCart.isLoaded,
        state.resumoCart.isLoadedPercent,
        state.perfHist.isLoaded,
        state.posCon.isLoaded,
        state.cartExp.isLoaded,
        state.fluxoAtivos.isLoaded,
        state.estats.isLoaded,
        state.capaPDF.isLoaded,
        state.resumoCart.isPercentToggle,
        state.preference.preferenceStyle.customizacao,
        state.preference.preferenceStyle.liberacao,
    ]);
    // 20/02/2025: N�O FUNCIONA COM O PDF ATUAL, APENAS COM O PDF QUE ACEITA LAYOUTS DA ISSUE CMDDAPP-576
    // const abas = preferenceLiberacao?.abas ?? ABAS_DEFAULT;
    // const mapeamentoIsLoaded: Partial<Record<typeAbas, boolean>> = {
    //   ResCart: isLoadedResumoCart,
    //   PerfHist: isLoadedPerfHist,
    //   PosCon: isLoadedPosCon,
    //   CartExp: isLoadedCartExp,
    //   FluxoAtivo: isLoadedFluxoAtivos,
    //   EstatAvancada: isLoadedEstats,
    // }
    // let checkLoaded = true;
    // for (const page of abas) {
    //   if (page in mapeamentoIsLoaded) {
    //     checkLoaded &&= (mapeamentoIsLoaded[page] ?? true);
    //   }
    // }
    // if (preferenceCustomizacao?.ResCart_percent || isPercentToggle) checkLoaded &&= isLoadedResumoCartPerf;
    let checkLoaded = isLoadedResumoCart && isLoadedPerfHist && isLoadedPosCon && isLoadedFluxoAtivos && isLoadedEstats && isLoadedCapaPDF;
    if (((_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_percent) !== null && _a !== void 0 ? _a : false) || isPercentToggle) {
        checkLoaded = checkLoaded && isLoadedResumoCartPerf;
    }
    const possuiCartExp = preferenceLiberacao === null || preferenceLiberacao === void 0 ? void 0 : preferenceLiberacao.abas.includes('CartExp');
    if (possuiCartExp) {
        checkLoaded = checkLoaded && isLoadedCartExp;
    }
    return checkLoaded;
};
export default useCheckAllLoaded;
